export interface AccountRegistration {
  accountId: string;
  accountType: string;
  registrationLines: string[];
  ageOfTermination: number;
  verifiedForSTP: boolean;
}

export interface AccountRegistrationResponse {
  accountRegistrations: AccountRegistration[];
}
